import { render, staticRenderFns } from "./Proyecto.vue?vue&type=template&id=ae88a288&scoped=true&"
import script from "./Proyecto.vue?vue&type=script&lang=js&"
export * from "./Proyecto.vue?vue&type=script&lang=js&"
import style0 from "./Proyecto.vue?vue&type=style&index=0&id=ae88a288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae88a288",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
